$('.hero__slider').slick({
      autoplay: true,
      autoplaySpeed: 3200,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      swipe: true,
      draggable: true,
      rows: 0,
      adaptiveHeight: true,
      speed: 800
    });

    $('.development__slider').slick({
      autoplay: true,
      autoplaySpeed: 3200,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      swipe: true,
      draggable: true,
      rows: 0,
      adaptiveHeight: true,
      speed: 800
    });